var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("scrollBox", {
    attrs: {
      data: _vm.data,
      loading: _vm.loading,
      total: _vm.total,
      showMore: _vm.showMore
    },
    on: {
      loadMore: function($event) {
        return _vm.$emit("loadMore")
      }
    },
    scopedSlots: _vm._u([
      {
        key: "left",
        fn: function(scope) {
          return [
            scope.row.msgType == "voice"
              ? _c("audio-record", {
                  attrs: { src: scope.row.audioUrl, type: "left" }
                })
              : scope.row.msgType == "file"
              ? _c("file-record", {
                  attrs: {
                    url: scope.row.fileUrl,
                    title: _vm.fileName(scope.row.fileUrl),
                    size: scope.row.fileSize || "未知",
                    fileType: scope.row.fileExt,
                    type: "left"
                  }
                })
              : scope.row.msgType == "image" || scope.row.msgType == "emotion"
              ? _c("img-record", {
                  attrs: { src: scope.row.imgUrl, type: "left" }
                })
              : _c("text-record", {
                  attrs: { content: scope.row.contactText, type: "left" }
                })
          ]
        }
      },
      {
        key: "right",
        fn: function(scope) {
          return [
            scope.row.msgType == "voice"
              ? _c("audio-record", {
                  attrs: { src: scope.row.audioUrl, type: "right" }
                })
              : scope.row.msgType == "file"
              ? _c("file-record", {
                  attrs: {
                    url: scope.row.fileUrl,
                    title: _vm.fileName(scope.row.fileUrl),
                    size: scope.row.fileSize || "未知",
                    fileType: scope.row.fileExt,
                    type: "right"
                  }
                })
              : scope.row.msgType == "image" || scope.row.msgType == "emotion"
              ? _c("img-record", {
                  attrs: { src: scope.row.imgUrl, type: "right" }
                })
              : _c("text-record", {
                  attrs: { content: scope.row.contactText, type: "right" }
                })
          ]
        }
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }